module.exports = __webpack_public_path__ + "static/media/lira-sign.edd0af88.svg";